import React from 'react';
import { Box, makeStyles, useTheme, useMediaQuery } from '@material-ui/core';
import {
  Modal,
  CheckBox,
  DefaultButton,
  Body2Text,
  colors,
} from 'design-system';
import ConsentText from './ConsentCollectionText';

const useStyles = makeStyles(() => ({
  container: {
    maxHeight: 392,
    padding: '5px 26px',
    border: '1px solid #D1D0D0',
    overflowY: 'scroll',
    color: colors.abbey,
    fontSize: 15,
    fontWeight: 400,
  },
}));

type Props = {
  onClose: () => void;
  onAccept: () => void;
  open: boolean;
  value: boolean;
  onCheck: (val: boolean) => void;
};

const ConsentCollectionModal = ({
  open,
  onClose,
  onAccept,
  value,
  onCheck,
}: Props): JSX.Element => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <Modal
      data-testid="swi-consent-modal"
      title="Consentimiento informado"
      open={open}
      maxWidth="sm"
      onCloseRequested={onClose}
    >
      <Box className={classes.container}>
        <ConsentText data-testid="informed-consent-text" />
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <Box sx={{ width: 'fit-content' }}>
          <CheckBox
            inputId="consentCheck"
            data-testid="consentCheck"
            checkTitle={
              <Body2Text id="swi-consent-text">
                He leído y estoy de acuerdo con la autorización de cobro
                automático a mi tarjeta.
              </Body2Text>
            }
            checkName="consentCheck"
            defaultValue={value}
            onChange={(val): void => {
              onCheck(val);
            }}
            style={{ alignItems: 'center', paddingTop: 15 }}
          />
        </Box>
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <Box
          data-testid="consent-button-container"
          sx={{ width: isMobile ? '100%' : '50%', mt: '10px' }}
        >
          <DefaultButton
            id="swi-consent-button"
            data-testid="swi-consent-button"
            onClick={onAccept}
            disabled={!value}
            fullWidth
          >
            Acepto
          </DefaultButton>
        </Box>
      </Box>
    </Modal>
  );
};

export default ConsentCollectionModal;
